export default __webpack_public_path__ + "static/media/homebg.7f5aa947.png";